import React from 'react';
import {observer} from 'mobx-react';
import {withState, t} from 'shared/core';
import {CompanyFilesState} from '../state';
import {AttachedDocumentDownload, Panel, EmojiTitle} from 'components';
import _ from 'lodash';

const CompanyFiles = observer(({uiState}) => {
  const {companyFiles, Emoji} = uiState;

  if(_.isEmpty(companyFiles)) return null;

  return (
    <Panel>
      <Panel.Header title={<EmojiTitle Emoji={Emoji} emojiKey='file_folder' title={t('hr_dashboard.company_files.Company Files')}/>}/>
      <div>
        {companyFiles.map(companyFile =>
          <div key={companyFile.id} className='mxn2'>
            <AttachedDocumentDownload doc={companyFile.file} name={companyFile.name}/>
          </div>
        )}
      </div>
    </Panel>
  );
});

export default withState(CompanyFiles, CompanyFilesState);
